import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Globals} from "../../global/globals";
import {SharedService} from "../common/shared.service";
import {Observable} from "rxjs";
import {FuncGrammarEntryPageDto} from "../../dtos/grammar/func/func-grammar-entry-page-dto";
import {FuncGrammarEntryDto} from "../../dtos/grammar/func/func-grammar-entry-dto";
import {FuncGrammarCategoryDto} from "../../dtos/grammar/func/func-grammar-category-dto";
import {FuncGrammarCategoryPageDto} from "../../dtos/grammar/func/func-grammar-category-page-dto";

@Injectable({
  providedIn: 'root'
})
export class FuncGrammarService {

  private funcGrammarBaseUri: string = this.globals.backendUri + '/grammar/functional';

  constructor(private httpClient: HttpClient, private globals: Globals, private sharedService: SharedService) {
  }

  /* -------------------- Entry -------------------- */

  searchEntries(params: HttpParams): Observable<FuncGrammarEntryPageDto> {
    return this.httpClient.get<FuncGrammarEntryPageDto>(this.funcGrammarBaseUri + '/entries', {params});
  }

  createEntry(newEntry): Observable<FuncGrammarEntryDto> {
    return this.httpClient.post<FuncGrammarEntryDto>(this.funcGrammarBaseUri + '/entries', newEntry);
  }

  updateEntry(newEntry): Observable<FuncGrammarEntryDto> {
    return this.httpClient.put<FuncGrammarEntryDto>(this.funcGrammarBaseUri + '/entries/' + newEntry.id, newEntry);
  }

  getEntry(id: number): Observable<FuncGrammarEntryDto> {
    return this.httpClient.get<FuncGrammarEntryDto>(this.funcGrammarBaseUri + '/entries/' + id)
  }

  deleteEntry(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.funcGrammarBaseUri + '/entries/' + id)
  }

  /* -------------------- Category -------------------- */

  getRootCategories(): Observable<FuncGrammarCategoryDto[]> {
    return this.httpClient.get<FuncGrammarCategoryDto[]>(this.funcGrammarBaseUri + '/categories/roots');
  }

  searchCategories(params: HttpParams): Observable<FuncGrammarCategoryPageDto> {
    return this.httpClient.get<FuncGrammarCategoryPageDto>(this.funcGrammarBaseUri + '/categories', {params});
  }

  createCategory(newCategory): Observable<FuncGrammarCategoryDto> {
    return this.httpClient.post<FuncGrammarCategoryDto>(this.funcGrammarBaseUri + '/categories', newCategory);
  }

  updateCategory(category): Observable<FuncGrammarCategoryDto> {
    return this.httpClient.put<FuncGrammarCategoryDto>(this.funcGrammarBaseUri + '/categories/' + category.id, category);
  }

  getCategoryByID(id: number): Observable<FuncGrammarCategoryDto> {
    return this.httpClient.get<FuncGrammarCategoryDto>(this.funcGrammarBaseUri + '/categories/' + id);
  }

  deleteCategory(id: number): Observable<any> {
    return this.httpClient.delete<any>(this.funcGrammarBaseUri + '/categories/' + id);
  }

  /* -------------------- Other -------------------- */

  updateExplanation(id: number, s: string): Observable<string> {
    return this.httpClient.put(this.funcGrammarBaseUri + '/categories/' + id + '/explanation', s, {responseType: 'text'});
  }

  getCategoryExplanation(id: number): Observable<string> {
    return this.httpClient.get(this.funcGrammarBaseUri + '/categories/' + id + '/explanation', {responseType: 'text'});
  }

  getEntryAsArray(entry: FuncGrammarEntryDto) {
    const tmpEntries = this.sharedService.filterNullOrEmpty(this.sharedService.extractReferences(entry));
    const entries = [];
    for (const tmpEntry of tmpEntries) {
      if (tmpEntry[0] !== 'id' && tmpEntry[0] !== 'name' && tmpEntry[0] !== 'receptive') {
        if (tmpEntry[0] === 'category') {
          tmpEntry[0] = 'Themenbaum'
          tmpEntry[1] = this.sharedService.getCategoryTree(tmpEntry[1]);
        } else if (tmpEntry[0] === 'productive') {
          tmpEntry[0] = 'Niveau'
        } else if (tmpEntry[0] === 'example') {
          tmpEntry[0] = 'Beispiel'
        } else if (tmpEntry[0] === 'comment') {
          tmpEntry[0] = 'Kommentar'
        }
        entries.push(tmpEntry)
      }
    }
    return entries
  }
}
